export enum TypeSearchFilterOptions {
    PRIMARY_HOUSE = "primary_market__house",
    PRIMARY_APARTMENT = "primary_market__apartment",
    AFTERMARKET_HOUSE = "aftermarket__house",
    AFTERMARKET_APARTMENT = "aftermarket__apartment",
    LOT = "lot"
}
